<ui-simple-dialog-layout (clickCancel)="clickCancel.emit()">
  <span slot="title">{{ 'cockpit.documents.previewDialog.title' | transloco }}</span>
  <div class="flex flex-col gap-2">
    <h3 class="text-sm font-semibold leading-6">{{ document() | documentFilename }}</h3>

    <div
      class="h-[54vh] sm:h-[60vh] px-6 py-5 bg-surface-variant-magic dark:bg-surface-variant-magic-darkmode rounded-lg outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode"
    >
      <app-document-preview
        class="w-full h-full"
        [document]="document()"
        [organizationID]="organizationID()"
      />
    </div>
  </div>
  <div class="w-full flex flex-col sm:flex-row gap-3" slot="footer">
    <div class="flex-1 sm:flex">
      @if (document().fileType.startsWith('LMA_')) {
        <a
          [href]="['/organizations', organizationID(), 'documents', document().id].join('/')"
          target="_blank"
        >
          <ui-button mode="outlined" expand="full" type="button">
            <ng-icon name="heroArrowTopRightOnSquare" size="20" slot="start" class="!block" />
            {{ 'cockpit.documents.previewDialog.openInNewTab' | transloco }}
          </ui-button>
        </a>
      } @else {
        <app-document-download-button [document]="document()" [organizationID]="organizationID()">
          <ui-button
            mode="outlined"
            expand="full"
            type="button"
            [disabled]="document().fileType.startsWith('LMA_')"
          >
            <ng-icon name="heroArrowDownTray" size="20" slot="start" class="!block" />
            {{ 'cockpit.documents.previewDialog.download' | transloco }}
          </ui-button>
        </app-document-download-button>
      }
    </div>
    <ui-button mode="outlined" expand="full" type="button" (click)="clickCancel.emit()">{{
      'cockpit.documents.previewDialog.close' | transloco
    }}</ui-button>
  </div>
</ui-simple-dialog-layout>
